import React, { useEffect, useState, useRef } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import ComEvalCheckTable from '../components/company-evaluation/ComEvalCheckTable';
import ComEvalList from '../components/company-evaluation/ComEvalList';
import NavbarText from '../components/NavbarText';
import axios from "axios";
import * as securityHelper from "../helper/SecurityHelper";
import Snackbar from '../components/Snackbar';

interface Evnt {
  evntId: number;
  evntName: string;
  evntCompany: string;
  boothType: string;
  place: string;
}

interface Company {
  comId: number;
  comName: string;
  representWork: string;
  represent: string;
  regNum: string;
  hostComName: string;
  cmpnySeq: number;
  sctrGbCd: string;
}

export default function CompanyEval() {
  const navigate = useNavigate();
  const initialCompany = { comId: 0, comName: '', representWork: '', represent: '', regNum: '', hostComName: '', cmpnySeq: 0, sctrGbCd: '' };
  const [tab, setTab] = useState(1);
  const [evntList, setEvntList] = useState<Evnt[]>([]);
  const [companyList, setCompanyList] = useState<Company[]>([]);
  const [selectEvnt, setSelectEvnt] = useState('');
  const [selectCompany, setSelectCompany] = useState<Company>(initialCompany);
  const [isCompany, setIsCompany] = useState(false);
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const voltRef = useRef<any>();
  const memoRef = useRef<any>();
  const [fileSrc, setFileSrc] = useState('');
  const user: any = securityHelper.getLoginUser();
  const exbtPlcRef = useRef<any>(null);
  const bthNoRef = useRef<any>(null);
  const [voltCodeDataList, setVoltCodeDataList] = useState<any>([]);
  const [voltScor, setVoltScor] = useState<number>(0);
  const [voltSctrGbCd, setVoltSctrGbCd] = useState('');
  const [saving, setSaving] = useState(false);
  const btnRef = useRef<any>();
  const [snackbarTxt, setSnackbarTxt] = useState('');
  useEffect(() => {
    if (snackbarTxt) {
      setTimeout(() => setSnackbarTxt(''), 2000)
    }
  }, [snackbarTxt]);

  useEffect(() => {

    if (fileRef.current) {
      const fileList = fileRef.current.files;
      let imgSrc;

      if (fileList.length > 0) {
        imgSrc = URL.createObjectURL(fileList[0]);
        setFileSrc(imgSrc);
      }
    }


  }, [fileName])

  useEffect(() => {
    if (selectCompany) {
      fn_retrieveVoltCodeDataList(selectCompany.sctrGbCd);
    }
  }, [selectCompany]);

  const fn_retrieveVoltCodeDataList = async (sctrGbCd: any) => {
    console.log(sctrGbCd)
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveVoltCodeDataList', { sctrGbCd: sctrGbCd });
    setVoltCodeDataList(rtrnData.data);
  }

  const fileHandler = () => {
    fileRef.current.click();
  };
  const backEvent = () => {
    if (tab === 1) { navigate(-1); }
    else if (tab === 2) { setTab(1); setIsCompany(false); setSelectCompany(initialCompany); }
    else if (tab === 3) { setTab(2); };
  };
  const stepTwo = () => {
    if (selectEvnt === '') { return alert('행사를 선택해주세요.') }
    setIsCompany(true);
    setTab(2);
  };
  const stepThree = () => {
    if (selectCompany.comName === '') { return alert('업체를 선택해주세요.') }
    setTab(3);
  };
  const register_btn = () => {
    btnRef.current.setAttribute("readonly", "readonly");
    setSaving(true);
  }
  useEffect(() => { if (saving) { register(); }}, [saving]);
  const register = async () => {
    const voltCd = voltRef.current.value;
    const memo = memoRef.current.value;
    const fileList = fileRef.current.files;
    const exbtPlcCd = exbtPlcRef.current?.value;
    const bthNo = bthNoRef.current?.value;
    const formData = new FormData();

    if (user.auth !== 'KOX') {
      if (!exbtPlcCd) {
        setSnackbarTxt('장소를 선택해 주십시오.');
        exbtPlcRef.current.focus();
        btnRef.current.removeAttribute("readonly");
        setSaving(false);
        return;
      }

      if (!bthNo) {
        setSnackbarTxt('부스번호를 입력해 주십시오.');
        btnRef.current.removeAttribute("readonly");
        setSaving(false);
        return;
      }
    }

    if (!voltCd) {
      setSnackbarTxt('위반내용을 선택해 주십시오.');
      voltRef.current.focus();
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      return;
    }

    if (fileList.length == 0) {
      setSnackbarTxt('사진을 등록해 주십시오.')
      btnRef.current.removeAttribute("readonly");
      setSaving(false);
      return;
    }

    if (fileList.length > 0) {
      formData.append('bfFiles', fileList[0]);
    }

    const score = voltScor * (-1);
    const jsonObject = {
      rgstCmpnySeq: user.companySeq,
      chkTrgtCmpnySeq: selectCompany.cmpnySeq,
      memo: memo,
      prcsStat: '001',
      rgstrSeq: user.seq,
      chkGbCd: '002',
      voltGbCd: voltCd,
      trgtEvntSeq: selectEvnt,
      exbtPlcCd: exbtPlcCd,
      bthNo: bthNo,
      voltScor: score,
      sctrGbCd: voltSctrGbCd
    }

    formData.append('jsonData', JSON.stringify(jsonObject));

    const rtrnData = await axios.post('admin/api/sftyChk/saveSftyChkData', formData);

    if (rtrnData.data > 0) {
      setSnackbarTxt('저장 되었습니다.');
      setTimeout(() => window.location.reload(), 1800)
    }
  };
  const fn_retrieveTodayEvntList = async () => {
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveTodayEvntList');
    setEvntList(rtrnData.data);
  }
  const fn_retrieveCmpnyListByEvnt = async () => {
    console.log(selectEvnt)
    const rtrnData = await axios.post('admin/api/sftyChk/retrieveCmpnyListByEvnt', { evntSeq: selectEvnt });
    setCompanyList(rtrnData.data);
  }

  useEffect(() => {
    // axios 행사 정보 가져오기
    fn_retrieveTodayEvntList();

  }, []);
  useEffect(() => {
    fn_retrieveCmpnyListByEvnt();
    // 다음 누를 때, 행사에 대한 업체 정보 가져오기

  }, [isCompany]);

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={backEvent}>업체평가</NavbarText>
      <Tab tab={tab} />
      <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-107px)] md:h-[calc(100%-267px)]'>
        <div className='pt-12 mb-20 md:pt-[30px] md:mb-[50px]'>
          {tab !== 3 && <ComEvalList tab={tab} evntList={evntList} selectEvnt={selectEvnt} setSelectEvnt={setSelectEvnt} companyList={companyList} selectCompany={selectCompany} setSelectCompany={setSelectCompany} />}
          {tab === 3 && <ComEvalCheckTable user={user} fileSrc={fileSrc} selectEvnt={selectEvnt} selectCompany={selectCompany} fileName={fileName} fileHandler={fileHandler} setFileName={setFileName} fileRef={fileRef} voltRef={voltRef} memoRef={memoRef} exbtPlcRef={exbtPlcRef} bthNoRef={bthNoRef} voltCodeDataList={voltCodeDataList} setVoltScor={setVoltScor} setVoltSctrGbCd={setVoltSctrGbCd}/>}
        </div>
        <button ref={btnRef} onClick={tab === 1 ? stepTwo : tab === 2 ? stepThree : register_btn}
          className={tab !== 3 ?
            `font-preLight text-15 md:text-37 text-white w-[260px] sm:w-[308px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto pt-10 pb-10 mb-20 md:pt-[25px] md:pb-[25px] md:mb-[50px]`
            : `font-preLight text-15 md:text-37 text-white w-[260px] sm:w-[308px] md:w-[750px] h-43 md:h-[107px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto pt-10 pb-10 mb-20 md:pt-[25px] md:pb-[25px] md:mb-[50px]`}>
          {tab !== 3 ? '다음' : '안전 점검 등록'}
        </button>
      </div>
    </div>
  );
}

const Tab = ({ tab }: any) => {
  return (
    <div className='w-full h-55 md:h-[110px] flex items-center justify-evenly px-17 md:px-[42px] bg-back text-13 sm:text-15 md:text-37'>
      <p className={tab === 1 ? `text-point font-preLight` : `font-preLight`}>① 행사 선택</p>
      <IoIosArrowForward className={tab === 1 ? `text-point` : ``} />
      <p className={tab === 2 ? `text-point font-preLight` : `font-preLight`}>② 업체 선택</p>
      <IoIosArrowForward className={tab === 2 ? `text-point` : ``} />
      <p className={tab === 3 ? `text-point font-preLight` : `font-preLight`}>③ 안전 점검</p>
    </div>
  );
};